import { css } from 'linaria';

export const reviewsTitle = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 20px;
  }
`;

export const reviewList = css`
  display: grid;
  gap: 24px 20px;
  padding: 0;
  margin: 0;
  list-style: none;

  li {
    position: relative;
  }

  @media (--from-desktop) {
    grid-auto-rows: 327px;
    grid-template-columns: repeat(7, 1fr);
  
    li {
      grid-column: span 2;
    }

    li:nth-child(10n + 1),
    li:nth-child(10n + 7) {
      grid-column: span 4;
    }

    li:nth-child(10n+2),
    li:nth-child(10n+5),
    li:nth-child(10n+6),
    li:nth-child(10n+8) {
      grid-column: span 3;
    }
  }

  @media (--to-desktop) {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: auto;

    li {
      height: 210px;
    }

    li:nth-child(10n + 1),
    li:nth-child(10n + 6) {
      grid-column: span 2;
      height: 444px;
    }
  }

  @media (--only-mobile) {
    gap: 16px;
    grid-auto-rows: auto;

    li {
      height: 158px;
    }

    li:nth-child(10n + 1),
    li:nth-child(10n + 6) {
      height: 331px;
    }
  }
`;

export const reviewCard = css`
  width: 100%;
  height: 100%;
  padding: 0;
  font-family: inherit;
  text-align: left;
  border: none;
  border-radius: var(--rounding-xl);
  cursor: pointer;

  &:hover {
    [data-qa="review-content"] {
      display: block;
    }
  }
`;

export const reviewPhoto = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--rounding-xl);
`;

export const reviewsShowMoreBtnContainer = css`
  margin-top: 32px;
  display: flex;
  justify-content: center;

  @media (--only-mobile) {
    width: 100%;
    margin-top: 20px;
  }
`;

export const reviewInfoIcon = css`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  background-color: var(--background-accent);
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (--only-mobile) {
    width: 20px;
    height: 20px;
  }
`;
